// extracted by mini-css-extract-plugin
export default {"mapHistory":"LocationHistory_mapHistory__z9C6s","popup":"LocationHistory_popup__OnW0A"};